<template lang="pug">
.page(v-if="loaded")
  .vacancy(v-if="vacancy")
    .vacancy-details
      .edit
        RomatchAdminButton.admin-button(@click="switchPage") {{ switchText }}
        RomatchAdminButton.admin-button(@click="promptRemove = true") Verwijderen
        RomatchAdminButton.admin-button(@click="gotoEdit") Bewerken
      h1 {{ vacancy.title }}
      .basic-info
        span.info-part
          RomatchIcon(name="location" size="18px")
          span.info-label {{ vacancy.location }}
        span.info-part
          RomatchIcon(name="briefcase" size="18px")
          span.info-label {{ vacancy.employment }}
      transition(name="fade" mode="out-in")
        router-view(:vacancy="vacancy")
  div(v-else)
    h1 404
    p De vacature waar u naar zoekt bestaat niet
  RomatchPromptModal(
    :show="promptRemove" @yes="remove" @no="promptRemove = false"
    message="Weet je zeker dat je deze vacature wil verwijderen?")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VacancyReactionForm from '@/components/VacancyReactionForm.vue'
import RomatchPromptModal from '@/components/RomatchPromptModal.vue'

export default {
  name: 'VacancyDetails',
  components: { VacancyReactionForm, RomatchPromptModal },
  data() {
    return {
      vacancy: null,
      promptRemove: false,
      loaded: false,
    }
  },
  computed: {
    ...mapGetters('vacancies', ['findVacancy']),
    switchText() {
      return this.$route.name === 'reactions' ? 'Toon details' : 'Toon reacties'
    },
  },
  methods: {
    ...mapActions('vacancies', ['maybeFetchVacancies', 'deleteVacancy']),
    switchPage() {
      if (this.$route.name === 'reactions') {
        this.gotoSubRoute('vacancydetails')
      } else {
        this.gotoSubRoute('reactions')
      }
    },
    gotoSubRoute(name) {
      this.$router.push({
        name,
        params: {
          id: this.vacancy.id,
        },
      })
    },
    goBack() {
      this.$router.push({ name: 'vacancies' })
    },
    async remove() {
      try {
        await this.deleteVacancy(this.vacancy.id)
        this.promptRemove = false
        this.goBack()
        this.$notifySuccess('Vacature verwijderd')
      } catch (e) {
        this.$notifyError('Er ging iets mis bij het verwijderen van de vacature')
        console.error(e)
      }
    },
    gotoEdit() {
      this.$router.push({
        name: 'editvacancy',
        params: {
          id: this.vacancy.id,
        },
      })
    },
  },
  async mounted() {
    const id = this.$route.params.id
    await this.maybeFetchVacancies()
    this.vacancy = await this.findVacancy(id)
    this.loaded = true
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

.page
  max-width romatch-max-width
  margin auto

h1, h3
  margin 1rem 0
  font-weight bold
  text-align left

.basic-info
  display flex
  margin 3rem 0

  .info-part
    float right
    display flex
    align-items center
    margin-right 3rem

    svg
      margin-right 0.7rem

p, button
  margin-bottom 1rem

.vacancy
  padding 0 2rem

.vacancy-details
  margin-bottom 3rem
  position relative
  text-align left

  .edit
    position absolute
    top 0
    right 0

.admin-button
  margin-left 1rem
</style>
